import { render, staticRenderFns } from "./zone-purchase.vue?vue&type=template&id=f3fa3da6&scoped=true"
import script from "./zone-purchase.vue?vue&type=script&lang=js"
export * from "./zone-purchase.vue?vue&type=script&lang=js"
import style0 from "../../assets/commoon/css/common.css?vue&type=style&index=0&id=f3fa3da6&prod&scoped=true&lang=css&external"
import style1 from "./zone-purchase.vue?vue&type=style&index=1&id=f3fa3da6&prod&scoped=true&lang=css"
import style2 from "./zone-purchase.vue?vue&type=style&index=2&id=f3fa3da6&prod&lang=css"
import style3 from "./zone-purchase.vue?vue&type=style&index=3&id=f3fa3da6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fa3da6",
  null
  
)

export default component.exports